import $ from "jquery";

$(function() {
    $(".bl-projlist").each(function() {
        const $bl = $(this);
        initProjektList($bl);
    });
});

function initProjektList($bl) {
    const $btnshowfilter = $bl.find(".btnshowfilter");
    $btnshowfilter.on("click", function() {
        const wasVisible = $ctrfilter.is(":visible");
        $ctrfilter.fadeToggle(200);
        $btnshowfilter.toggleClass("active");
        const isVisible = !wasVisible;
        if(!isVisible) {
            $ctrfilter.find("li").removeClass("active");
            animateUpdateItemVisibility();
        }
    });

    const $ctrfilter = $bl.find(".ctrfilter");
    const $ctritems = $bl.find(".ctritems");
	$ctrfilter.on("click", "li", function() {
        const $clickedLi = $(this);
        $clickedLi.toggleClass("active");
        $ctrfilter.find("li").not($clickedLi).removeClass("active");
        animateUpdateItemVisibility();
	});

    function animateUpdateItemVisibility() {
        $ctritems.fadeOut(200, function() {
            updateItemVisibility($bl);
            $ctritems.fadeIn(200);
        });
    }
    
    //Hash Links
    const hash = window.location.hash;
    if(hash) {
        const filter = hash.substring(1);
        $bl.find(".ctrfilter li[data-phaseid='"+filter+"']").trigger("click");
    }
}

function updateItemVisibility($bl) {
    const filters = [];
    $bl.find(".ctrfilter li.active").each(function() {
        const $li = $(this);
        const filter = $li.data("phaseid");
        filters.push(filter);
    });

    if(filters.length == 0) {
        //No filter active => show all
        $bl.find(".item").removeClass("filter-hidden");
        return;
    }

    $bl.find(".item").addClass("filter-hidden");
    for(const filter of filters) {
        $bl.find(".item").each(function() {
            const $item = $(this);
            if($item.data("tags").includes(filter)) {
                $item.removeClass("filter-hidden");
            }
        });
    }
}
